import { useEffect, useState } from "react";
import {
  buscarDocumentosLegais,
  DocumentosPorTipo,
} from "./buscarDocumentosLegais";
import { LegalTipo } from "./tipos";

interface EstadoDocumentosLegais {
  documentos: DocumentosPorTipo;
  carregando: boolean;
  erro: string | null;
}

/**
 * Carrega a versão mais recente de cada documento legal em uma única requisição.
 *
 * const { documentos, carregando, erro } = useDocumentosLegais(TIPOS_LEGAIS);
 */
export const useDocumentosLegais = (
  tipos: LegalTipo[],
): EstadoDocumentosLegais => {
  const [documentos, setDocumentos] = useState<DocumentosPorTipo>({});
  const [carregando, setCarregando] = useState<boolean>(true);
  const [erro, setErro] = useState<string | null>(null);
  // Serializado porque o array de tipos é recriado a cada render do chamador.
  const chaveDosTipos = tipos.join(",");

  useEffect(() => {
    let montado = true;

    buscarDocumentosLegais(chaveDosTipos.split(",") as LegalTipo[])
      .then((encontrados) => {
        if (montado) setDocumentos(encontrados);
      })
      .catch(() => {
        if (montado) setErro("Não foi possível carregar os documentos.");
      })
      .finally(() => {
        if (montado) setCarregando(false);
      });

    return () => {
      montado = false;
    };
  }, [chaveDosTipos]);

  return { documentos, carregando, erro };
};
